import { typeMixProduct } from "./mixProduct"
import { queryAllMixCollections } from "./queries/queryAllMixCollections"
import { queryAllMixProducts } from "./queries/queryAllMixProducts"
import { queryMixArticles } from "./queries/queryMixArticles"
import { queryMixColors } from "./queries/queryMixColors"

const mixProductSchema = {
  types: [typeMixProduct],
  resolvers: {
    Query: {
      ...queryAllMixCollections,
      ...queryAllMixProducts,
      ...queryMixArticles,
      ...queryMixColors,
    },
  },
}

export default mixProductSchema
